// Module
var code = "<div class=\"row\"> <div class=\"question col-12\"> <div class=\"message mine\"> <div class=\"row question\"> <span class=\"content\"></span> </div> <div class=\"row question\"> <small class=\"date_name\"></small> </div> </div> </div> </div>";
// Exports
module.exports = code;